import { render, staticRenderFns } from "./Gerer-rv.vue?vue&type=template&id=6bc4c6c0&scoped=true&"
import script from "./Gerer-rv.vue?vue&type=script&lang=js&"
export * from "./Gerer-rv.vue?vue&type=script&lang=js&"
import style0 from "./Gerer-rv.vue?vue&type=style&index=0&id=6bc4c6c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc4c6c0",
  null
  
)

export default component.exports